var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent100"},[_c('WallBackground'),_c('star-background',{staticClass:"tateyure",attrs:{"is-flash":true}}),_c('oraora-component',{staticStyle:{"position":"absolute"},attrs:{"is-jolyn":_vm.isJolyn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }